module.exports = __webpack_public_path__ + "static/media/1_r_gorshok_85.89_76.48.56a165c2.png";